module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_arrow_right05-467ee832bc353e56138d2708cdeb480b.svg";